export const timePartIsSingularCheck = (timePiece: number): boolean => {
    return timePiece >= 20 ? timePiece % 10 === 1 : timePiece === 1;
};
